import { Field, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import { StripePaymentIntent } from '../stripe'
import { StripeBankTransferInfo } from './StripeBankTransferInfo'

@ObjectType()
@InputType('StripePaymentInput')
export class StripePayment extends BaseEntity {
  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  sessionId?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  paymentIntent?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  source?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  paymentId?: string

  @Field(() => StripePaymentIntent)
  metadata: StripePaymentIntent

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  paymentLinkId?: string

  @Field(() => StripeBankTransferInfo, { nullable: true })
  @Prop({ _id: false, required: false })
  bankTransferInfo?: StripeBankTransferInfo
}
